import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FlexLayoutModule } from '@angular/flex-layout';
import { FilterEngineV2Component, ToolbarV2Module } from '@iot-platform/iot-platform-ui';
import { MasterViewEngineModule } from '@iot-platform/table-engine';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';
import { TranslatePipe } from '@ngx-translate/core';
import { ReceiversShellComponent } from './containers/receivers-shell/receivers-shell.component';
import { ReceiversRoutingModule } from './receivers-routing.module';
import { ReceiversEffects } from './state/effects/receivers.effects';
import * as fromReceivers from './state/reducers';

@NgModule({
  imports: [
    CommonModule,
    FlexLayoutModule,
    TranslatePipe,
    ToolbarV2Module,
    MasterViewEngineModule,
    ReceiversRoutingModule,
    StoreModule.forFeature(fromReceivers.featureKey, fromReceivers.reducers),
    EffectsModule.forFeature([ReceiversEffects]),
    FilterEngineV2Component
  ],
  declarations: [ReceiversShellComponent]
})
export class ReceiversModule {}
